<template>
    <section class="home-sec5">
        <div class="motion-container">
            <img src="../assets/images/pic (2)109.png" alt="" class="motion-bg">
            <img src="../assets/images/motion-2.gif" alt="" class="motion">
        </div>
        <div class="content-bg">
            <div class="content">
                <div class="users">
                    <span>30,000,000</span>
                    <span> کاربر فعال ماهانه در فیلو</span>
                </div>
                <span v-if="width <= 360" class="divider"></span>
                <div class="visits">
                    <span>300,000,000</span>
                    <span>بازدید ماهانه در فیلو</span>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { inject } from "vue";
export default {
    name: "HomeSection5",
    setup() {
        const width = inject('viewportWidth');

        return {width};
    },
};
</script>
<style scoped>
.home-sec5 {
    margin-inline: 4.792%;
}

.motion-container {
    margin-inline: 26.2961%;
    position: relative;
}

.motion-container,
.motion-bg {
    aspect-ratio: 823 / 516;
    max-height: 516px;
}

.motion-container,
.content,
.content div {
    display: flex;
}

.motion-container,
.content div {
    justify-content: center;
    align-items: center;
}

.motion-bg {
    z-index: 2;
}

.motion-bg,
.content-bg {
    width: 100%;
}

.motion-bg,
.motion {
    object-fit: contain;
}

.motion {
    aspect-ratio: 1 / 1;
    width: 54%;
    border-radius: 50%;
    position: absolute;
    z-index: 1;
}

.content-bg {
    background-color: rgba(231, 231, 231, 0.32);
    box-shadow: 0 2px 10px var(--shadow-light);
    backdrop-filter: blur(20px);
}

.content-bg,
.divider {
    border-radius: 20px;
}

.content {
    padding: 7% 10.76%;
    justify-content: space-between;
    margin-top: -14.29%;
}

.content div {
    flex-direction: column;
}

.content span {
    font-family: IRANYekan-Bold;
    font-size: 30px;
    line-height: 42px;
    opacity: 0;
    animation: fadeIn 2s ease-in forwards;
}

.users> :first-child,
.visits> :first-child {
    color: var(--main-pink);
}

.divider {
    width: 4px;
    height: 100px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.22);
    backdrop-filter: 70px;
}

@media screen and (min-width: 1921px) {
    .home-sec5 {
        width: 1736px;
        margin-inline: auto;
    }
}

@media screen and (max-width: 1440px) {
    .content span {
        font-size: 24px;
        line-height: 34px;
    }
}

@media screen and (max-width: 1024px) {
    .home-sec5 {
        margin-inline: 5.556%;
    }

    .content-bg {
        background-color: var(--glass-morphism);
        box-shadow: 0 0 2px var(--shadow-light);
    }

    .content span {
        font-size: 20px;
    }
}

@media screen and (max-width: 768px) {
    .content {
        padding: 12% 5.76% 7%;
    }

    .content div {
        line-height: 30px;
    }

    .content span {
        font-size: 16px;
    }
}

@media screen and (max-width: 425px) {
    .content {
        padding-inline: 1.76%;
    }

    .content span {
        text-align: center;
    }
}

@media screen and (max-width: 360px) {
    .motion-container {
        margin-inline: 2.66%;
    }

    .motion-container,
    .motion-bg {
        aspect-ratio: 300 / 188;
        max-height: 188px;
    }

    .motion {
        width: 57%;
    }

    .content {
        margin-top: -29.29%;
        padding-block: 36.41% 5.782%;
    }

    .content div {
        flex-basis: 114px;
    }
}
</style>